import React, { useEffect, useState, useRef } from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';
import { Link, useNavigate } from 'react-router-dom';
import RequestService from '../../services/requestService';
import ProviderService from '../../services/providerservice';
import { GetDataEmail, GetDataUserID, GetDataFullName } from '../../components/utils/data-storage';

const STATUS_MAP = {
    1:  { label: 'New', cls: 'badge-status--new' },
    2:  { label: 'Cancel', cls: 'badge-status--cancel' },
    3:  { label: 'Return', cls: 'badge-status--return' },
    4:  { label: 'Cancel', cls: 'badge-status--cancel' },
    5:  { label: 'In-Progress', cls: 'badge-status--inprogress' },
    6:  { label: 'In-Progress', cls: 'badge-status--inprogress' },
    7:  { label: 'In-Progress', cls: 'badge-status--inprogress' },
    8:  { label: 'In-Progress', cls: 'badge-status--inprogress' },
    9:  { label: 'In-Progress', cls: 'badge-status--inprogress' },
    10: { label: 'Complete', cls: 'badge-status--completed' },
    11: { label: 'Complete', cls: 'badge-status--completed' },
};

const STATUS_TABS = [
    { key: 'all',      label: 'All',         value: 'all' },
    { key: 'new',      label: 'New',         value: '1' },
    { key: 'inprog',   label: 'In Progress', value: '5,6,7,9' },
    { key: 'return',   label: 'Return',      value: '3' },
    { key: 'cancel',   label: 'Cancel',      value: '2,4' },
    { key: 'complete', label: 'Complete',    value: '8,10,11' },
];

// ── โชว์ (done/total) เฉพาะกลุ่ม In-Progress ที่มีหลายปลายทาง (>1) ──
// ── done = จำนวน request_detail ที่ is_complete == 1 (เหมือน AdminRequests) ──
const getInProgressLabel = (row) => {
    const details = row.request_details || [];
    const total = details.length;
    if (total <= 1) return 'In-Progress';
    const done = details.filter((d) => d.is_complete == 1).length;
    return `In-Progress (${done}/${total})`;
};

// ── ชื่อ provider สำรอง เมื่อไม่มี receiver ใน service_type = 3 (ชำระค่าบริการ) ──
// ── key อ้างอิง id จริงจาก m_sub_service_type (4=ไฟฟ้า, 5=ประปา, 6=โทรศัพท์) ──
const TRANSACTION_PROVIDER_NAMES = {
    4: 'การไฟฟ้านครหลวง / ภูมิภาค',
    5: 'การประปานครหลวง / ภูมิภาค',
    6: 'ผู้ให้บริการโทรศัพท์',
};

const formatDate = (value) => {
    if (!value) return '-';
    const [y, m, day] = String(value).slice(0, 10).split('-');
    return `${day}/${m}/${y}`;
};

const ROWS_OPTIONS = [10, 20, 30, 40, 50];

const SORT_OPTIONS = [
    { key: 'date_desc', label: 'วันที่ล่าสุด' },
    { key: 'date_asc',  label: 'วันที่เก่าสุด' },
];

const isOtherProviderBranch = (detail) => {
    const val = Number(detail?.destination_id_provider_branch);
    return val === 0 || val === -1;
};

const getContactNo = (detail) => {
    if (!detail) return '-';
    return detail.destination_phone_number || '-';
};

const getDestinationName = (detail) => {
    if (!detail) return '-';
    return detail.destination_name || '-';
};

const UserRequests = () => {
    const navigate = useNavigate();

    const [dataReq, setDataReq] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [statusFilter, setStatusFilter] = useState('all');
    const [currentPage, setCurrentPage] = useState(1);
    const [sortKey, setSortKey] = useState('');
    const [showSortDropdown, setShowSortDropdown] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [showRowsDropdown, setShowRowsDropdown] = useState(false);
    const [bankProviders, setBankProviders] = useState({});
    const [tabCounts, setTabCounts] = useState({});

    const rowsDropdownRef = useRef(null);
    const sortDropdownRef = useRef(null);

    const userName = GetDataFullName ? GetDataFullName() : 'User';

    useEffect(() => {
        loadDataRequests(1, rowsPerPage, statusFilter, search);
        loadBankProviders();
        loadTabCounts();
    }, []);

    useEffect(() => {
        const handler = (e) => {
            if (rowsDropdownRef.current && !rowsDropdownRef.current.contains(e.target)) setShowRowsDropdown(false);
            if (sortDropdownRef.current && !sortDropdownRef.current.contains(e.target)) setShowSortDropdown(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    // ── โหลดรายชื่อธนาคารครั้งเดียว ไว้ lookup ชื่อจาก destination_id_provider ──
    // ── เพราะ request_details เก็บแค่ id ธนาคาร ไม่ได้เก็บชื่อ (destination_company = ชื่อสาขา) ──
    const loadBankProviders = async () => {
        try {
            const res = await ProviderService.SearchProvider({ id_service_type: 2, status: 1 });
            const map = Object.fromEntries(
                (res.data.result || []).map((p) => [p.id, p.name_th])
            );
            setBankProviders(map);
        } catch (err) {
            console.error('loadBankProviders error:', err);
        }
    };

    // ── นับจำนวนคำขอต่อ status (ของ user คนนี้เท่านั้น) เอาแค่ยอด total ──
    const loadTabCounts = async () => {
        try {
            const counts = {};
            await Promise.all(
                STATUS_TABS.map(async (tab) => {
                    const params = {
                        sender_id_user: parseInt(GetDataUserID()),
                        status: 1,
                        limit: 1,
                        offset: 0,
                        id_workflow_status: tab.value === 'all' ? [] : tab.value.split(',').map(Number),
                    };
                    const resp = await RequestService.SearchRequest(params);
                    counts[tab.key] = resp.data.total || 0;
                })
            );
            setTabCounts(counts);
        } catch (err) {
            console.error('loadTabCounts error:', err);
        }
    };

    const getReceiverName = (detail) => {
        if (!detail) return '-';
        // type 2: ชื่อธนาคาร (lookup จาก provider id, fallback ชื่อสาขาระหว่างโหลด)
        if (detail.id_service_type === 2) {
            return bankProviders[detail.destination_id_provider]
                || detail.destination_company
                || '-';
        }
        // type 3: สถานที่ชำระบริการ
        if (detail.id_service_type === 3) {
            if (isOtherProviderBranch(detail)) return detail.destination_name || '-';
            return detail.destination_company
                || TRANSACTION_PROVIDER_NAMES[detail.id_sub_service_type]
                || '-';
        }
        // type 1: บริษัทปลายทาง (free text)
        return detail.destination_company || '-';
    };

    // ── เพิ่ม param status/q เพื่อให้ filter และ search ทำงานจริง ──
    const loadDataRequests = async (page = 1, rows = rowsPerPage, statusF = statusFilter, q = search) => {
        try {
            const offset = (page - 1) * rows;
            const params = {
                sender_id_user: parseInt(GetDataUserID()),
                status: 1,
                limit: rows,
                offset,
                id_workflow_status: statusF === 'all' ? [] : statusF.split(',').map(Number),
            };
            if (q && q.trim()) {
                params.search = q.trim();
            }
            const resp = await RequestService.SearchRequest(params);
            if (resp.data.is_success && resp.data.result) {
                setDataReq(resp.data.result);
                setTotal(resp.data.total || 0);
            }
        } catch (err) { console.error('Failed to load requests', err); }
    };

    const onClickRow = (row) => {
        navigate('/user/request-detail/' + btoa(row.id + '::AR'), { replace: true });
    };

    // ── debounce search เพื่อไม่ยิง API ถี่เกินไปตอนพิมพ์ ──
    const searchTimeoutRef = useRef(null);
    const handleSearchChange = (e) => {
        const value = e.target.value;
        setSearch(value);
        setCurrentPage(1);
        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        searchTimeoutRef.current = setTimeout(() => {
            loadDataRequests(1, rowsPerPage, statusFilter, value);
        }, 2000);
    };

    useEffect(() => {
        return () => {
            if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
        };
    }, []);

    const totalPages = Math.max(1, Math.ceil(total / rowsPerPage));
    const safePage = Math.min(currentPage, totalPages);

    // ── sort ฝั่ง FE (เรียงเฉพาะข้อมูลในหน้าปัจจุบัน เหมือน AdminRequests) ──
    const sorted = [...dataReq].sort((a, b) => {
        if (sortKey === 'date_asc')  return new Date(a.service_date) - new Date(b.service_date);
        if (sortKey === 'date_desc') return new Date(b.service_date) - new Date(a.service_date);
        return 0;
    });

    const sortLabel = SORT_OPTIONS.find((o) => o.key === sortKey)?.label || 'Sort By';

    const goPage = (p) => {
        if (p >= 1 && p <= totalPages) {
            setCurrentPage(p);
            loadDataRequests(p, rowsPerPage, statusFilter, search);
        }
    };

    const pageNumbers = (() => {
        const start = Math.max(1, safePage - 2);
        const end   = Math.min(totalPages, safePage + 2);
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    })();

    const countLabel = total === 0
        ? '0 รายการ'
        : `${(safePage - 1) * rowsPerPage + 1}–${Math.min(safePage * rowsPerPage, total)} จาก ${total} รายการ`;

    return (
        <React.Fragment>
            <div className="user-requests-page">
                <div className="page-header">
                    <div className="page-header__titles">
                        <h2>Welcome, {userName}</h2>
                        <p>รายการคำขอของคุณ</p>
                    </div>
                    <Link to="/user/request-detail/MDo6QVI=" className="btn-new-request">
                        <i className="ri-add-line" />
                        New Request
                    </Link>
                </div>

                <div className="request-card">

                    <div className="sp-chip">
                        <div className="sp-tabs__list">
                            {STATUS_TABS.map((tab) => (
                                <button
                                    key={tab.key}
                                    className={`sp-tab ${statusFilter === tab.value ? 'sp-tab--active' : ''}`}
                                    onClick={() => {
                                        if (searchTimeoutRef.current) clearTimeout(searchTimeoutRef.current);
                                        setStatusFilter(tab.value);
                                        setCurrentPage(1);
                                        loadDataRequests(1, rowsPerPage, tab.value, search);
                                    }}
                                >
                                    {tab.label} {tabCounts[tab.key] ?? 0}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="table-toolbar">
                        <div className="table-toolbar__left">
                            <div className="search-input-wrap">
                                <i className="ri-search-line" />
                                <input
                                    type="text"
                                    placeholder="Search..."
                                    value={search}
                                    onChange={handleSearchChange}
                                />
                            </div>
                        </div>

                        <div className="table-toolbar__right">
                            <span className="pagination-info">{countLabel}</span>

                            <div className="rows-dropdown" ref={rowsDropdownRef}>
                                <button
                                    className="btn-icon"
                                    onClick={() => setShowRowsDropdown((v) => !v)}
                                >
                                    <i className="ri-more-2-fill" />
                                </button>
                                {showRowsDropdown && (
                                    <div className="rows-dropdown__menu">
                                        <div className="rows-dropdown__options">
                                            {ROWS_OPTIONS.map((opt) => (
                                                <div
                                                    key={opt}
                                                    className={`rows-dropdown__item${rowsPerPage === opt ? ' rows-dropdown__item--active' : ''}`}
                                                    onClick={() => {
                                                        setRowsPerPage(opt);
                                                        setCurrentPage(1);
                                                        loadDataRequests(1, opt, statusFilter, search);
                                                        setShowRowsDropdown(false);
                                                    }}
                                                >
                                                    {opt} รายการ
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </div>

                            <div className="ar-sort-dropdown" ref={sortDropdownRef}>
                                <button className="ar-sort-btn" onClick={() => setShowSortDropdown((v) => !v)}>
                                    {sortLabel} <i className="ri-arrow-down-s-line" />
                                </button>
                                {showSortDropdown && (
                                    <div className="ar-dropdown-menu">
                                        {SORT_OPTIONS.map((o) => (
                                            <div
                                                key={o.key}
                                                className={`ar-dropdown-item ${sortKey === o.key ? 'ar-dropdown-item--active' : ''}`}
                                                onClick={() => { setSortKey(o.key); setShowSortDropdown(false); }}
                                            >
                                                {o.label}
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    <div style={{ overflowX: 'auto' }}>
                        <table className="requests-table">
                            <thead>
                                <tr>
                                    <th>Ref no.</th>
                                    <th>Service date</th>
                                    <th>Requester</th>
                                    <th>Receiver</th>
                                    <th>Contact no.</th>
                                    <th>Destination</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                {sorted.length === 0 ? (
                                    <tr>
                                        <td className='table-empty' colSpan={7} style={{ textAlign: 'center', padding: '40px', color: '#8492a6' }}>
                                            ยังไม่มีรายการคำขอ
                                        </td>
                                    </tr>
                                ) : (
                                    sorted.map((row, idx) => {
                                        const status = STATUS_MAP[row.id_workflow_status] || { label: '', cls: 'badge-status--cancel' };
                                        // ── กลุ่ม In-Progress → โชว์ (done/total) เมื่อมีหลายปลายทาง ── อื่นๆ ใช้ label เดิม ──
                                        const statusLabel = status.cls === 'badge-status--inprogress'
                                            ? getInProgressLabel(row)
                                            : status.label;
                                        return (
                                            <tr key={row.id || idx} onClick={() => onClickRow(row)}>
                                                <td className="ref-no">{row.ref_no}</td>
                                                <td className="col-muted">{formatDate(row.service_date)}</td>
                                                <td>{row.sender_name}</td>
                                                <td>{getReceiverName(row.request_details?.[0])}</td>
                                                <td className="col-muted">{getContactNo(row.request_details?.[0])}</td>
                                                <td>{getDestinationName(row.request_details?.[0])}</td>
                                                <td>
                                                    <span className={`badge-status ${status.cls}`}>
                                                        {statusLabel}
                                                    </span>
                                                    {row.id_workflow_status === 3 && row.admin_remark && (
                                                        <div style={{ fontSize: 11, color: '#ef4444', marginTop: 4 }}>
                                                            {row.admin_remark}
                                                        </div>
                                                    )}
                                                </td>
                                            </tr>
                                        );
                                    })
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div className="table-pagination">
                        <Pagination>
                            <PaginationItem disabled={safePage === 1}>
                                <PaginationLink first onClick={() => goPage(1)} />
                            </PaginationItem>
                            <PaginationItem disabled={safePage === 1}>
                                <PaginationLink previous onClick={() => goPage(safePage - 1)} />
                            </PaginationItem>
                            {pageNumbers.map((p) => (
                                <PaginationItem key={p} active={p === safePage}>
                                    <PaginationLink onClick={() => goPage(p)}>{p}</PaginationLink>
                                </PaginationItem>
                            ))}
                            <PaginationItem disabled={safePage === totalPages}>
                                <PaginationLink next onClick={() => goPage(safePage + 1)} />
                            </PaginationItem>
                            <PaginationItem disabled={safePage === totalPages}>
                                <PaginationLink last onClick={() => goPage(totalPages)} />
                            </PaginationItem>
                        </Pagination>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default UserRequests;